/* eslint-disable @typescript-eslint/naming-convention */
import { FetchJsonOptions } from '@brandfolder/react';
import { useEffect, useState } from 'react';

import { fetchJson } from '@api/ApiHelper';

import {
  AutocompleteFetchState,
  AutocompleteRequestParams,
  AutocompleteResponse,
  FaceFetchType,
  PeoplePageRequestParams,
  Person,
  PersonDetailsRequestParams,
} from './customPeopleTagTypes';

const localDevBrandfolderKey = ''; // replace me with the bf_key from the HeyTeam Brandfolder in stage (DO NOT COMMIT)
const localOrgKey = ''; // replace me with the org_key from the Product Testing org in stage (DO NOT COMMIT)
const localDevelopment = process.env.NODE_ENV === 'development';

const payloadKeys = {
  bf_key: localDevelopment ? localDevBrandfolderKey : BFG.brandfolder_key,
  org_key: localDevelopment ? localOrgKey : BFG.organization_key,
  current_user: BFG.currentUser.email,
};

const headers = {
  'Content-Type': 'application/json',
  Accept: '*/*',
  Authorization: `Bearer ${BFG.org_token}`,
};

const getRequestOptions = (
  payload: PeoplePageRequestParams | PersonDetailsRequestParams
): Pick<FetchJsonOptions, 'body' | 'headers' | 'method'> => ({
  body: {
    ...payloadKeys,
    ...payload,
  },
  headers,
  method: 'POST',
});

const fetchFaceData = <T, Y>(
  payload: T,
  fetchType: FaceFetchType
): Promise<Y> => {
  return fetchJson({
    url: `${BFG.DATA_INSIGHTS_URL}/people-tagging/${fetchType}`,
    ...getRequestOptions(payload),
  });
};

export const useAutocompletePeopleTags = (tag: string, personId: string): AutocompleteFetchState => {
  const [autocompleteResults, setAutocompleteResults] = useState<Person[]>([]);

  useEffect(() => {
    if (!tag) {
      setAutocompleteResults([]);
      return;
    }

    const fetchTags = async (): Promise<void> => {
      try {
        const response = await fetchFaceData<AutocompleteRequestParams, AutocompleteResponse>(
          {
            query: tag,
          },
          'autocomplete'
        );
        // filter out the person we're currently on
        const filteredResults = response.data.filter(
          (result: Person) => result.person_id !== personId
        );
        setAutocompleteResults(filteredResults);
      } catch {
        console.error('error fetching autocomplete results');
      }
    };

    if (tag) {
      // quick fix - handles the async nature of the search
      // TODO: worth looking into debounce/ a different solution
      const search = setTimeout(() => {
        fetchTags();
      }, 200);
      return () => clearTimeout(search);
    }
  }, [personId, tag]);

  return {
    autocompleteResults,
  };
};
